/**
 * Created by Bart Decorte
 * Date: 16/11/2018
 * Time: 13:57
 */
import Swal from 'sweetalert2';

class ConfirmActions {
  constructor() {
    this.bindListeners();
  }

  bindListeners() {
    $('[data-confirmation]').on('click', (ev) => this.lConfirmAction(ev));
  }

  lConfirmAction(ev) {
    let $elt = this._getRealElement(ev, '[data-confirmation]');
    let halt = this._halt(ev);

    let confirmation = $elt.data('confirmation');
    let continueText = $elt.data('continue');
    let cancelText = $elt.data('cancel');

    if (typeof window.MouseEvent !== 'function') halt = false;

    if ($elt.is(':disabled') || $elt.hasClass('disabled')) {
      // Nothing should happen either way
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    }

    if (halt) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ev.stopPropagation();

      Swal.fire({
        title: 'Are you sure?',
        text:
          confirmation != '' ? confirmation : 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText:
          typeof cancelText !== typeof undefined ? cancelText : 'Cancel',
        confirmButtonText:
          typeof continueText !== typeof undefined ? continueText : 'Continue',
        customClass: {
          confirmButton: 'btn ml-1 mr-1 btn-danger',
          cancelButton: 'btn ml-1 mr-1 btn-light',
        },
        buttonsStyling: false,
      }).then(({ isConfirmed, isDismissed }) => {
        if (isConfirmed) {
          let ce = new MouseEvent('click', {
            clientX: -1000,
          });

          if ($elt.get(0).tagName == 'A') {
            $elt.get(0).dispatchEvent(ce);
          } else {
            $elt.trigger($.Event('click', { clientX: -1000 }));
          }
        }
      });
    }
  }

  _getRealElement(ev, restriction) {
    return $(ev.target).is(restriction)
      ? $(ev.target)
      : $(ev.target)
          .parents(restriction)
          .first();
  }

  _halt(ev) {
    if (ev.clientX < 0) return false;

    return true;
  }
}

export default ConfirmActions;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/ConfirmActions.js